'use client'


export default function Loading() {
  // Or a custom loading skeleton component
  return (
    <div className="w-full min-h-screen flex flex-col gap-4 justify-center items-center">
      <div className="loader"></div>

    </div>
  );
}
